module.exports = __webpack_public_path__ + "img/rain-pipe.a01a610f.png";